<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.125 1.5C16.44 1.5 20.75 5.81 20.75 11.125C20.75 16.44 16.44 20.75 11.125 20.75C5.81 20.75 1.5 16.44 1.5 11.125C1.5 5.81 5.81 1.5 11.125 1.5ZM11.125 19.117C15.538 19.117 19.117 15.538 19.117 11.125C19.117 6.712 15.538 3.133 11.125 3.133C6.712 3.133 3.133 6.712 3.133 11.125C3.133 15.538 6.712 19.117 11.125 19.117ZM10.094 14.9065C10.091 14.7692 10.1154 14.6326 10.1659 14.5048C10.2163 14.3771 10.2918 14.2607 10.3879 14.1625C10.4839 14.0643 10.5987 13.9863 10.7253 13.933C10.8519 13.8797 10.9879 13.8523 11.1253 13.8523C11.2626 13.8523 11.3986 13.8797 11.5252 13.933C11.6518 13.9863 11.7666 14.0643 11.8626 14.1625C11.9587 14.2607 12.0342 14.3771 12.0846 14.5048C12.1351 14.6326 12.1595 14.7692 12.1565 14.9065C12.1506 15.1761 12.0393 15.4326 11.8466 15.6212C11.6538 15.8097 11.3949 15.9153 11.1253 15.9153C10.8556 15.9153 10.5967 15.8097 10.4039 15.6212C10.2112 15.4326 10.0999 15.1761 10.094 14.9065ZM10.609 12.5C10.5635 12.4997 10.52 12.4815 10.4878 12.4493C10.4557 12.4171 10.4376 12.3735 10.4375 12.328V6.485C10.4375 6.39 10.515 6.313 10.6095 6.313H11.6405C11.7355 6.313 11.8125 6.3905 11.8125 6.485V12.3285C11.8125 12.4235 11.735 12.5005 11.6405 12.5005H10.61L10.609 12.5Z"
      fill="#B6B6B6"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
